import * as React from 'react'
import { OpeningTimesService } from './openingTimesService'

export const OpeningTimesServiceContext = React.createContext(null as any as OpeningTimesService)
